import React, { useState, useEffect } from 'react';
import './CardSlider.css'; // You can define your own styles here

const CardSlider = ({ imageNames }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    // Automatically transition to the next slide every 3 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageNames.length);
    }, 1500);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, [imageNames.length]);

  // Function to get the array of images for the current slide
  const getCurrentImages = () => {
    const images = [];
    const numImagesToShow = window.innerWidth > 768 ? 3 : 2; // Show 3 images on larger screens, 2 on smaller screens
    for (let i = 0; i < numImagesToShow; i++) {
      images.push(imageNames[(currentImageIndex + i) % imageNames.length]);
    }
    return images;
  };

  return (
    <div className="image-slider">
      <div className="slider-images">
        {getCurrentImages().map((imageName, index) => (
          <img
            key={index}
            src={process.env.PUBLIC_URL + '/' + imageName}
            alt={`Slide ${index}`}
            className="slider-image"
            style={{borderRadius:"10px",height:"210px",width:"340px",margin:"10px"}}
          />
        ))}
      </div>
    </div>
  );
};

export default CardSlider;
